import React, { useEffect } from "react";
import "./kakaoMap.css";
export default function MapContainer() {
  const { kakao } = window;
  let listTest = [1]
  useEffect(() => {
    let mapContainer = document.getElementById("map"),
      mapOption = {
        center: new kakao.maps.LatLng(33.451475, 126.570528),
        level: 3,
      };

    let map = new kakao.maps.Map(mapContainer!, mapOption);


    listTest.forEach(()=>{
      console.log("tewtrwe")
    })
    let marker = new kakao.maps.Marker({
      map: map,
      position: new kakao.maps.LatLng(33.450701, 126.573427),
      zIndex: 2,
    });
    kakao.maps.event.addListener(marker, "click", function () {
      const markerLocatin = marker.getPosition();
      overlay.setPosition(markerLocatin);
      overlay.setMap(map);
    });

    let content = `
      <div class="wrap">
        <div class="info">
          <div class="title">
            kakao
            <div class="close" title="닫기"></div>
          </div>
        </div>
      </div>
    `;

    let overlay = new kakao.maps.CustomOverlay({
      content: content,
      map: map,
      position: marker.getPosition(),
      zIndex: 10,
      
    });

    const close = document.querySelectorAll(".close");
    close.forEach((element) => {
      element.addEventListener("click", function () {
        overlay.setMap(null);
      });
    });
    overlay.setMap(null);
  }, [kakao]);
  return (
    <div>
      <div
        id="map"
        style={{
          width: "1000px",
          height: "1000px",
        }}
      ></div>
    </div>
  );
}